import { DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { IntegrationsSyncableStateStatusEnum } from 'generated/resources/graphql'

import {
  type AggregatableStatuses,
  AggregatedStatus,
  aggregateStatuses,
} from 'modules/integrations/lib/syncableStatus'
import { translatedAggregatedStatus } from 'modules/integrations/lib/translatedAggregatedStatus'

export const statusesItems = (
  statusesGroups: Array<AggregatableStatuses | Set<IntegrationsSyncableStateStatusEnum>>,
  isExportMode: boolean
): DropdownItem[] => {
  const items: DropdownItem[] = []

  statusesGroups
    .map((statuses) => {
      const statusesArray: AggregatableStatuses =
        statuses instanceof Set
          ? Array.from(statuses)
          : Array.isArray(statuses)
            ? statuses
            : statuses
      return aggregateStatuses(statusesArray)
    })
    .reduce((map, groupedStatus) => {
      if (groupedStatus == undefined) return map
      map.set(groupedStatus, (map.get(groupedStatus) ?? 0) + 1)
      return map
    }, new Map<AggregatedStatus, number>())
    .forEach((value, key) => {
      if (key === 'syncing') return

      items.push({
        label: `${translatedAggregatedStatus(key, isExportMode)}: ${value}`,
        critical: key === 'failed',
      })
    })

  return items
}
